/* eslint-disable no-template-curly-in-string */
import { createEntityDescriptor } from '../../redux/entity-descriptor';

export default {
  holdingCompanies: createEntityDescriptor('holdingCompanies', {
    list: {
      url: '/api/clients/holding.json',
    },
  }),
};
